import { APP_STATUSES } from "utils/AppStatusContext"

export interface RouterEntry<AllStatuses extends string> {
    path: string
    status: ((searchParams: URLSearchParams) => AllStatuses | undefined) | AllStatuses
    match?: AllStatuses[]
}

export const AnalyticStatusConfig: RouterEntry<APP_STATUSES>[] = [
    {
        path: "/survey/psy",
        status: APP_STATUSES.survey,
    },
    {
        path: "/results",
        status: APP_STATUSES.survey_results,
    },
    {
        path: "/psychologist/collection/:id",
        status: APP_STATUSES.psy_collection,
    },
    {
        path: "/psychologist/list",
        status: (searchParams: URLSearchParams) => {
            if (searchParams.get("email_source") === "competence_questionnaire") {
                return APP_STATUSES.results_from_email
            } else {
                return APP_STATUSES.list
            }
        },
        match: [APP_STATUSES.results_from_email, APP_STATUSES.list],
    },
    {
        path: "/psychologist/:id",
        status: APP_STATUSES.profile,
    },
    {
        path: "/psychologists/free/booking",
        status: APP_STATUSES.free_psys_page,
    },
    {
        path: "/psychologists/free",
        status: APP_STATUSES.free_psys_page,
    },
    {
        path: "/psychologists:filter(/[^/]+|)/:page(\\d+)",
        status: APP_STATUSES.search_page,
    },
    {
        path: "/psychologists/:filter/:slug",
        status: APP_STATUSES.profile,
    },
    {
        path: "/psychologists:filter(/[^/]+|)",
        status: APP_STATUSES.search_page,
    },
    {
        path: "/booking/:id",
        status: APP_STATUSES.booking_details,
    },
    {
        path: "/booking",
        status: APP_STATUSES.booking,
    },
    {
        path: "/payment/:id",
        status: APP_STATUSES.payment,
    },
    {
        path: "/psychologist-account/*",
        status: APP_STATUSES.psychologist_account,
    },
    {
        path: "/my/authorization",
        status: APP_STATUSES.client_authorization,
    },
    {
        path: "/my/call/*",
        status: APP_STATUSES.video_call_page,
    },
    {
        path: "/my/*",
        status: APP_STATUSES.client_account,
    },
    {
        path: "/funnel-docs",
        status: APP_STATUSES.funnel_docs,
    },
    {
        path: "/ssg/psychologists/:filter/:page",
        status: APP_STATUSES.search_page,
    },
    {
        path: "/ssg/psychologists/:filter",
        status: APP_STATUSES.search_page,
    },
    {
        path: "/my/card-attachment",
        status: APP_STATUSES.client_card_attachment,
    },
    {
        path: "/internal/call/*",
        status: APP_STATUSES.internal_call_page,
    },
]
